import * as types from "./types";

export default {
  [types.SET_PAGE_TITLE]: ({ commit }, payload) => {
    commit(types.MUTATE_SET_PAGE_TITLE, payload);
  },
  [types.SET_COLLAPSE]: ({ commit }, payload) => {
    commit(types.MUTATE_SET_COLLAPSE, payload);
  },
  [types.SET_OVERLAY]: ({ commit }, payload) => {
  	commit(types.MUTATE_SET_OVERLAY, payload);
  }
};
